import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import moment from 'moment';
import {
  VEHICLE_ISSUES_LOAD_ALL,
  VEHICLE_ISSUES_RESET_PAGE,
  VEHICLE_ISSUES_GRID_SORT,
  VEHICLE_ISSUES_GRID_CURRENT_PAGE,
  VEHICLE_ISSUES_GRID_SEARCH_TEXT,
  VEHICLE_ISSUES_GRID_SEARCH_FILTER_BY,
  VEHICLE_ISSUES_GRID_SEARCH_FILTER_BY_COLUMN,
  VEHICLE_ISSUES_CHANGE_STATE
} from '../actionTypes';
import { hide as hideBusyIndicator, show as showBusyIndicator } from './busyIndicatorActions';
import { showAlert, clearAllAlerts } from './alertActions';
import VehiclesService from '../../services/VehiclesService';
import { formatErrorMessage, getDayEnd, getDayStart } from '../../utils/common';
import VehicleIssuesService from '../../services/VehicleIssuesService';

export const refreshData = (startDate: string, endDate: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
  dispatch(showBusyIndicator());
  dispatch(clearAllAlerts());
  VehicleIssuesService.getAllVehicleIssues(getDayStart(startDate) ?? moment().startOf('week').add(1, 'day').toDate(), getDayEnd(endDate) ?? moment().endOf('week').add(1, 'day').toDate())
    .then((result) => {
      dispatch({
        type: VEHICLE_ISSUES_LOAD_ALL,
        data: result
      });
    }).catch((err) => {
      dispatch(showAlert(formatErrorMessage(JSON.parse(err.response))));
    }).then(() => {
      dispatch(hideBusyIndicator());
    });
};

export const reset = () => ({
  type: VEHICLE_ISSUES_RESET_PAGE
});

export const searchByText = (text: string) => ({
  type: VEHICLE_ISSUES_GRID_SEARCH_TEXT,
  data: text
});

export const searchByWarning = (filterBy = 'all') => ({
  type: VEHICLE_ISSUES_GRID_SEARCH_FILTER_BY,
  data: filterBy
});

export const changeFilterByColumn = (col = 'all_col') => ({
  type: VEHICLE_ISSUES_GRID_SEARCH_FILTER_BY_COLUMN,
  data: col
});

export const changePage = (page = 1) => ({
  type: VEHICLE_ISSUES_GRID_CURRENT_PAGE,
  data: page
});

export const changeSortModel = (sortModel = []) => ({
  type: VEHICLE_ISSUES_GRID_SORT,
  data: sortModel
});

export const selectStates = (states: Array<number> = []): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
  dispatch({ type: VEHICLE_ISSUES_CHANGE_STATE, data: states });
};
